import { styled } from '@mui/system';
import { Box, CardActionArea } from '@mui/material';

export const List = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: theme.spacing(2),
}));

export const SuggestionCard = styled(CardActionArea)(({ theme }) => ({
  height: '100%',
  padding: theme.spacing(2, 1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  backgroundColor: theme.palette.primary[800],
}));
